// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__12U2K","primary":"styles_primary__3HQ5-","secondary":"styles_secondary__2pJ5d"};